<div class="page-body-wrapper">
    <mat-accordion class="example-headers-align" multi>

        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Profilim
                </mat-panel-title>
                <mat-panel-description style="justify-content: end;">
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="container">
                <div class="row my-2">
                    <div class="col-lg-8 order-lg-2">
                        <mat-tab-group style="height: auto;">
                            <mat-tab label="Profil">
                                <div class="py-4" style="height: 100%; overflow: hidden;">
                                <h5 class="mb-3">{{currentUser.name}} {{currentUser.surname}}</h5>
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6>Telefon</h6>
                                        <p>
                                            {{profileResponse?.tel}}
                                        </p>
                                        <h6>E-mail</h6>
                                        <p>
                                            {{currentUser?.email}}
                                        </p>
                                        <h6>Depertman</h6>
                                        <p>
                                            {{currentUser?.department?.name}}
                                        </p>
                                        <h6>Ünvan</h6>
                                        <p>{{profileResponse?.jobTitleName}}</p>
                                    </div>
                                    <div class="col-md-6">

                                        <h6>Tck No</h6>
                                        <p>
                                            {{profileResponse?.tck}}
                                        </p>
                                        <h6>Yönetici</h6>
                                        <p>
                                            {{profileResponse?.managerName}} {{profileResponse?.managerSurname}}
                                        </p>
                                        <h6>İşe Giriş Tarihi</h6>
                                        <p>
                                            {{profileResponse?.workStartDate | date:'shortDate'}}
                                        </p>
                                    </div>

                                </div>
                                <!--/row-->
                            </div>
                            </mat-tab>
                            <mat-tab label="Kalan İzinlerim">
                                <div class="py-4" style="height: 100%; overflow: hidden;">
                                    <div class="alert alert-info" *ngIf="showAlert">
                                        <button mat-icon-button class="float-right" (click)="closeAlert()">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        Kalan <strong>mazeret ve yıllık</strong> İzinleriniz
                                    </div>
                                <table mat-table [dataSource]="absenceDataSource" class="mat-elevation-z1 w-100">
                                    <!-- İzin Türü Kolonu -->
                                    <ng-container matColumnDef="type">
                                        <th mat-header-cell *matHeaderCellDef> İzin Türü </th>
                                        <td mat-cell *matCellDef="let element"> {{element.type}} </td>
                                    </ng-container>

                                    <!-- Kalan Gün Kolonu -->
                                    <ng-container matColumnDef="days">
                                        <th mat-header-cell *matHeaderCellDef class="text-right"> Kalan Gün </th>
                                        <td mat-cell *matCellDef="let element" class="text-right"> {{element.days}} </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                    <div class="col-lg-4 order-lg-1 text-center">
                        <img class="profile-photo-wrapper"
                            style="border-radius: 50%;width: 200px;max-width: 900px;margin-left: auto; margin-right: auto;"
                            alt=" " *ngIf="profileResponse?.profilePhoto"
                            src="{{fileUploadRoot}}/{{profileResponse?.profilePhoto?.filePath}}">
                        <i class="material-icons icon" *ngIf="!profileResponse?.profilePhoto"
                            style="font-size: 150px;color: #707173">
                            account_circle </i>
                        <h6 class="mt-2">Profil Resmi</h6>
                        <label class="custom-file">
                            <input type="file" id="file" class="custom-file-input">
                        </label>
                    </div>
                </div>
            </div>

            <!-- bitis -->

        </mat-expansion-panel>

    </mat-accordion>
</div>
<div class="page-body-wrapper">
    <mat-accordion class="example-headers-align" multi>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Şifre Değiştir
                </mat-panel-title>
                <mat-panel-description style="justify-content: end;">
                </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- sifre degistir govde -->
            <form [formGroup]="updatePasswordForm" (ngSubmit)="updatePassword()">

                <div class="form-group">
                    <mat-form-field class="lookup-form-field">
                        <input type="password" matInput placeholder="Mevcut Şifre" formControlName="currentPassword"
                            style="width: 250px;">
                        <mat-error *ngIf="updatePasswordForm.controls['currentPassword'].hasError('required')">
                            Mevcut şifreyi girmelisiniz...
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <mat-form-field class="lookup-form-field">
                        <input type="password" matInput placeholder="Yeni Şifre" formControlName="newPassword"
                            style="width: 250px;">
                        <mat-error *ngIf="updatePasswordForm.controls['newPassword'].hasError('required')">
                            Yeni şifreyi girmelisiniz(En az 8 karakter)...
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <mat-form-field class="lookup-form-field">
                        <input type="password" matInput placeholder="Yeni Şifre(Tekrar)" formControlName="newPassword2"
                            style="width: 250px;">
                        <mat-error
                            *ngIf="updatePasswordForm.controls['newPassword2'].hasError('required') &&
                                         (updatePasswordForm.controls['newPassword2'].dirty || updatePasswordForm.controls['newPassword2'].touched)">
                            Yeni şifreyi tekrar girmelisiniz(En az 8 karakter)...
                        </mat-error>
                    </mat-form-field>
                </div>

                <button type="submit" class="btn btn-primary"
                    [disabled]="!updatePasswordForm.valid">{{submitButtonName}}</button>
            </form>
            <!-- bitis -->

        </mat-expansion-panel>

    </mat-accordion>
</div>